export const TOAST_SHOW = 'TOAST_SHOW';
export const TOAST_CLOSE = 'TOAST_CLOSE';

export const show = message => {
    return {
        type: TOAST_SHOW,
        toast: {
            visible: true,
            message,
        },
    };
};

export const close = () => {
    return {
        type: TOAST_CLOSE,
        toast: {
            visible: false,
        },
    };
};
